/*

Client Service

*/



import axios from "../../axios/index.js"


export default {

    getClient(code) {
        return axios.get("/clientConnectee/" + code,
        { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },

}
